<template>
  <el-row>
    <el-col :span="6">
      <basic-container>
        <div>项目名称</div>
        <el-select
          v-model="projectId"
          clearable
          placeholder="请选择"
          style="margin: 20px 0"
          @change="projectChange"
        >
          <el-option v-for="item in projectList" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
        <!--  -->
        <el-input placeholder="请输入内容" v-model="filterText" style="margin-bottom: 20px">
          <template slot="append">
            <i class="el-icon-plus" @click="addCatalog()" v-if="permissionList.menuAdd"></i>
          </template>
        </el-input>
        <el-tree
          v-if="!throttle && this.projectId !== ''"
          ref="tree"
          :data="treeData"
          node-key="id"
          :expand-on-click-node="false"
          lazy
          :load="loadNode"
          :props="treeProps"
          :filter-node-method="filterNode"
          @node-click="nodeClick"
        >
          <span slot-scope="{ node }" class="custom-tree-node">
            <span style="flex: 3">
              <el-tooltip class="item" effect="dark" :content="node.label" placement="top-start">
                <span>{{
                  node.label.length > 10 ? node.label.slice(0, 8) + '...' : node.label
                }}</span>
              </el-tooltip>
            </span>
            <span style="flex: 1" class="menu">
               <el-tooltip class="item" effect="dark" content="新增子目录" placement="top">
                 <i class="iconfont iconicon_subordinate"  @click="addCatalog(node)" v-if="permissionList.menuAdd"></i>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="编辑" placement="top">
                <i class="iconfont iconicon_compile"  @click="editCatalog(node)" v-if="permissionList.menuEdit"></i>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="删除" placement="top">
                <i class="iconfont iconicon_delete" @click="delCatalog(node)" v-if="permissionList.menuDel"></i>
              </el-tooltip>
              <!-- <i class="el-icon-plus"  @click="addCatalog(node)" v-if="permissionList.menuAdd"></i>
              <i class="el-icon-edit"  @click="editCatalog(node)" v-if="permissionList.menuEdit"></i>
              <i class="el-icon-delete" @click="delCatalog(node)" v-if="permissionList.menuDel"></i> -->
            </span>
          </span>
        </el-tree>
      </basic-container>
    </el-col>

    <el-col :span="18">
      <basic-container>
        <avue-crud
          :option="option"
          :data="data"
          :page.sync="page"
          :permission="permissionList"
          :before-open="beforeOpen"
          v-model="currentRow"
          ref="crud"
          @row-del="rowKnowledgeDel"
          @search-change="searchKnowledgeChange"
          @search-reset="searchKnowledgeReset"
          @current-change="currentChange"
          @size-change="sizeChange"
          @refresh-change="onLoad"
          :table-loading="tableLoading"
          @selection-change="selectionChange"
        >
          <template slot="menuLeft">
            <el-button
              type="primary"
              size="small"
              icon="el-icon-plus"
               v-if="permissionList.addBtn"
              @click="handleAddKnowledge"
            >
              发布
            </el-button>
            <el-button
              type="primary"
              size="small"
              icon="el-icon-service"
              v-if="permissionList.recommend"
              @click="handleRecomend()"
            >
              推荐
            </el-button>
          </template>
        </avue-crud>
      </basic-container>
    </el-col>

    <el-dialog
      :title="formTile"
      :visible.sync="formShow"
      width="50%"
      :before-close="handleClose"
      append-to-body
      :close-on-click-modal="false"
    >
      <Form
        v-if="formShow"
        :form="form"
        :projectList="projectList"
        @close="closeForm"
        :mode="formMode"
      />
    </el-dialog>



       <el-drawer
  title=""
  :visible.sync="viewShow"
  :direction="direction"
  append-to-body
  :before-close="handleClose"
  size="80%"
>
      <ViewKnowledge v-if="viewShow" :data="currentRow" />

</el-drawer>

    <!-- <el-dialog
      :visible.sync="viewShow"
      width="80%"
      :before-close="handleClose"
      append-to-body
      :close-on-click-modal="false"
    >
      <ViewKnowledge v-if="viewShow" :data="currentRow" />
    </el-dialog> -->

    <!-- <el-dialog
      :title="catalogFormTitle"
      :visible.sync="catalogDialogShow"
      width="50%"
      :before-close="handleClose"
      append-to-body
    ></el-dialog> -->

    <el-dialog
      :title="catalogFormTitle"
      :visible.sync="catalogDialogShow"
      width="50%"
      :before-close="handleClose"
      append-to-body
    >
      <el-form ref="form" :model="catalogForm" label-width="80px">
        <el-form-item label="上级目录" v-if="catalogFormTitle == '新增'">
          <el-input v-model="catalogForm.parentName" disabled></el-input>
        </el-form-item>
        <el-form-item label="目录名称">
          <el-input v-model="catalogForm.name" maxlength="200" show-word-limit></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="saveCatalog">创建</el-button>
          <el-button @click="cancelCreateCatalog">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      title="推荐列表"
      :visible.sync="recomendShow"
      width="80%"
      append-to-body
      :close-on-click-modal="false"
    >
      <el-form class="demo-form-inline">
        <el-form-item label="推荐原因">
          <el-input
            type="textarea"
            v-model="reason"
            placeholder=""
            maxlength="200"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item style="text-align: right">
          <el-button @click="recomendShow = false">取消</el-button>
          <el-button type="primary" @click="confirmRecomend">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </el-row>
</template>

<script>
import Form from './form';
import ViewKnowledge from './view';
import Recommend from './recommend';

  import {mapGetters} from "vuex";


import {
  getKnowledgeProjectMenu,
  saveKnowledgeProjectMenu,
  updateKnowledgeProjectMenu,
  removeKnowledgeProjectMenu,
  knowledgeProjectPage,
  delKnowledgeProject,
  recommend,
  getProjectList
} from '@/api/crmedical/knowledge/project';

export default {
  components: { Form, ViewKnowledge, Recommend },
  data() {
    return {
      catalogDialogShow: false,
      catalogFormTitle: '新增',
      catalogForm: {},
      formShow: false,
      formTitle: '发布',
      form: {},
      formMode: 'add',
      currentRow: {},
      viewShow: false,
      treeProps: {
        label: 'name',
        isLeaf: 'isLeaf',
      },
      throttle: false,
      treeData: [],
      currentMenuTreeNode: null,
      params: {},
      filterText: '',
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      projectList: [],
      projectId: '',
      projectName: '',
      option: {
        selection: true,
        searchShow: true,
        searchMenuSpan: 6,
        border: true,
        index: true,
        addBtn: false,
        viewBtn: true,
        // selection: true,
        dialogClickModal: false,
        column: [
          { label: '文件标题', prop: 'title', search: true },
          { label: '文件类型', prop: 'extension' },
          { label: '文件目录', prop: 'menuName' },
          { label: '文件说明', prop: 'content' },
          { label: '浏览次数', prop: 'accessNum' },
          { label: '下载次数', prop: 'downloadNum' },
          { label: '发布人', prop: 'userName' },
          { label: '发布日期', prop: 'createTime' },
        ],
      },
      data: [],
      tableLoading: false,
      recomendShow: false,
      selections: [],
      reason: '',
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.knowledgeprojectfile_add, false),
        viewBtn: this.vaildData(this.permission.knowledgeprojectfile_view, false),
        delBtn: this.vaildData(this.permission.knowledgeprojectfile_delete, false),
        editBtn: this.vaildData(this.permission.knowledgeprojectfile_edit, false),
        menuAdd: this.vaildData(this.permission.knowledgeprojectmenu_add, false),
        menuEdit: this.vaildData(this.permission.knowledgeprojectmenu_edit, false),
        menuDel: this.vaildData(this.permission.knowledgeprojectmenu_delete, false),
        recommend: this.vaildData(this.permission.knowledgeprojectfile_recommend, false),
      };
    },
  },
  created() {
    getProjectList().then((res) => {
      this.projectList = res.data;
      if (!this.projectId) {
        this.projectId = this.projectList[0].id;
        this.projectName = this.projectList[0].name;
      }
      this.loadList();
    });
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  methods: {
    projectChange(projectId) {
      const project = this.projectList.find((ele) => ele.id === projectId);
      this.projectName = project.name;
      this.currentMenuTreeNode = null;
      this.throttle = true;
      setTimeout(() => {
        this.throttle = false;
        this.loadList();
      }, 500);
    },
    loadNode(node, resolve) {
      const params = {
        parentId: node.data.id || 0,
        projectId: this.projectId,
      };
      getKnowledgeProjectMenu(params).then((res) => {
        res.data.forEach((ele) => {
          ele.isLeaf = !ele.hasChildren;
        });
        resolve(res.data);
      });
    },
    addCatalog(node) {
      this.catalogForm = {
        parentId: node ? node.data.id : 0,
        parentName: node ? node.data.name : '',
        projectId: this.projectId,
      };
      this.catalogFormTitle = '新增';
      this.catalogDialogShow = true;
    },
    cancelCreateCatalog() {
      this.catalogDialogShow = false;
    },
    saveCatalog() {
      if (this.throttle) return;
      this.throttle = true;
      let api = this.catalogForm.id ? updateKnowledgeProjectMenu : saveKnowledgeProjectMenu;
      api(this.catalogForm)
        .then(() => {
          this.throttle = false;
          this.catalogDialogShow = false;
        })
        .catch(() => {
          this.catalogDialogShow = false;
          this.throttle = false;
        });
    },
    editCatalog(node) {
      this.catalogFormTitle = '编辑';
      this.catalogForm = {
        id: node.data.id,
        name: node.data.name,
        projectId: this.projectId,
      };
      this.catalogDialogShow = true;
    },
    delCatalog(node) {
      const id = node.data.id;
      const fd = new FormData();
      fd.append('ids', id);
      this.$confirm('是否删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.throttle = true;
          return removeKnowledgeProjectMenu(fd);
        })
        .then((res) => {
          this.throttle = false;
          this.$message.success(res.msg);
        })
        .catch((v) => {
          this.throttle = false;
          if (v == 'cancel') {
            this.$message({
              type: 'info',
              message: '已取消删除',
            });
          }
        });
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    nodeClick(data) {
      this.currentMenuTreeNode = data;
      this.loadList();
    },
    loadList() {
      const params = {
        current: this.page.currentPage,
        size: this.page.pageSize,
        title: this.params.title || '',
        menuId: this.currentMenuTreeNode ? this.currentMenuTreeNode.id : '',
        projectId: this.projectId,
      };
      this.tableLoading = true;
      knowledgeProjectPage(params)
        .then((res) => {
          this.tableLoading = false;
          res.data.records.forEach((ele) => {
            ele.accessNum = ele.accessNum == -1 || !ele.accessNum ? 0 : ele.accessNum;
            ele.downloadNum = ele.downloadNum == -1 || !ele.downloadNum ? 0 : ele.downloadNum;
          });
          this.data = res.data.records;
          this.page.total = res.data.total;
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    searchKnowledgeChange(params, done) {
      this.params = params;
      this.loadList();
      done();
    },
    searchKnowledgeReset() {
      this.params = { projectId: this.projectId };
      this.loadList();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
      this.loadList();
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.loadList();
    },
    handleAddKnowledge() {
      if (this.currentMenuTreeNode) {
        this.form = {
          menuId: this.currentMenuTreeNode.id,
          menuName: this.currentMenuTreeNode.name,
          downloadFlag: 1,
          projectId: this.projectId,
          projectName: this.projectName,
        };
        this.formTitle = '发布';
        this.formMode = 'add';
        this.formShow = true;
      } else {
        this.$message.warning('请选择一个目录');
      }
    },
    closeForm() {
      this.formShow = false;
      this.loadList();
    },
    //知识内容
    beforeOpen(done, type) {
      if ('view' == type) {
        console.log('view==>');
        this.viewShow = true;
      }
      if (['edit'].includes(type)) {
        this.formMode = 'edit';
        this.form = this.currentRow;
        this.form.projectId = this.projectId;
        this.form.projectName = this.projectName;
        this.formShow = true;
      }
    },
    rowKnowledgeDel(row) {
      const id = row.id;
      const fd = new FormData();
      fd.append('ids', id);
      this.$confirm('是否删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return delKnowledgeProject(fd);
        })
        .then((res) => {
          this.loadList();
          this.$message.success(res.msg);
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    handleRecomend() {
      console.log('this.selections==>', this.selections);
      if (this.selections.length === 0) {
        this.$message.warning('请至少选择一个推荐资料');
        return;
      } else {
        this.recomendShow = true;
      }
    },
    selectionChange(v) {
      this.selections = v;
      console.log('arguments==>', arguments);
    },
    confirmRecomend() {
      // const postData = {
      //   id:this.selections.map(ele=>ele.id).toString(),
      //   cause:this.reason
      // }
      let fd = new FormData();
      fd.append('ids', this.selections.map((ele) => ele.id).toString());
      fd.append('cause', this.reason);
      recommend(fd).then((res) => {
        console.log('res recommend==>', res);
        this.recomendShow = false;
        this.$message.success(res.msg);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .custom-tree-node {
  position: relative;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  .menu{
    width: 40%;
    position: absolute;
    right: 0;
    // background: white;
    opacity: 1;
    display: flex;
    justify-content: space-between;
  }
}
</style>

